import { render, staticRenderFns } from "./ProductInfoStock.vue?vue&type=template&id=67952338"
import script from "./ProductInfoStock.vue?vue&type=script&lang=ts"
export * from "./ProductInfoStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67952338')) {
      api.createRecord('67952338', component.options)
    } else {
      api.reload('67952338', component.options)
    }
    module.hot.accept("./ProductInfoStock.vue?vue&type=template&id=67952338", function () {
      api.rerender('67952338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoStock.vue"
export default component.exports